var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#81BC3D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 35,
    width: 50,
    height: 5,
    rx: 2.5,
    fill: "#81BC3D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#81BC3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.e70ba3770ad6b6c762fd7a962161ae53.svg";
export { ForwardRef as ReactComponent };